import React from 'react'
import loadable from '@loadable/component'

import Markdown from 'markdown-to-jsx'
import styles from './text-section.module.sass'
import classNames from 'classnames'
import Numbers from '../Blocks/Numbers'
import GridGallery from '../Blocks/GridGallery'
import Button from '../Inlines/Button'
import Accent from '../Inlines/Accent'
import Image from '../Image'
import kebabCase from 'lodash/kebabCase'
// import ModalVideoButton from '../Modals/ModalVideoButton'
const LazyModalVideoButton = loadable(() => import('../Modals/ModalVideoButton'))
const ModalVideoButton = props => <LazyModalVideoButton {...props} />
// import ProfileItem from '../CardItems/ProfileItem'
const LazyProfileItem = loadable(() => import('../CardItems/ProfileItem'))
const ProfileItem = props => <LazyProfileItem {...props} />

const Box = ({ children, counter }) => (
  <div className={styles.box} data-counter={counter}>
    {children}
  </div>
)
const Checks = ({ children }) => <div className={styles.checks}>{children}</div>
const Base = ({ children }) => <div className={styles.base}>{children}</div>
const Icon = props => <Image className={styles.techIcon} src={`/images/technologies/${kebabCase(props.name)}.svg`} alt={props.name} />
const FakeLink = ({ children }) => <span className={styles.fakeLink}>{children}</span>

const Technologies = props => {
  return (
    <>
      {React.Children.map(props.children, child => {
        return (
          React.isValidElement(child) &&
          React.cloneElement(child, {
            className: classNames(styles.technologies, props.className),
            children: React.Children.map(child.props.children, child => {
              return (
                React.isValidElement(child) &&
                React.cloneElement(child, {
                  children: React.Children.toArray(child.props.children).concat(<FakeLink children="Learn More" />)
                })
              )
            })
          })
        )
      })}
    </>
  )
}

export default function TextSection({ columns, classes }) {
  return (
    <section className={classNames(styles.textSection, classes)}>
      <div className="container">
        <div className="row">
          {columns.map((column, i) => (
            <Markdown
              key={i}
              className={classNames(styles.column, column.classes)}
              options={{
                forceBlock: true,
                forceWrapper: true,
                overrides: {
                  Numbers,
                  Button,
                  ModalVideoButton,
                  GridGallery,
                  Image: {
                    component: Image,
                    props: { wrapper: true }
                  },
                  ProfileItem,
                  Accent,
                  Box,
                  Checks,
                  Base,
                  Technologies,
                  Icon
                }
              }}
            >
              {column.content}
            </Markdown>
          ))}
        </div>
      </div>
    </section>
  )
}
